import React, { useEffect, useState } from 'react';
import LoanAccountField from './LoanAccountField';


const AddLoanAccount = () => {
     return (
        <div className='mx-auto w-full p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add A Loan Account</h1>
            <LoanAccountField></LoanAccountField>
        </div>
    );
};

export default AddLoanAccount;